import React from 'react';
import ResetPasswordPage from './ResetPasswordPage';

const ResetPassword = () => (
	<section>
	  <ResetPasswordPage />
	</section>
);

export default ResetPassword;
